import useFetchAllProperties from 'components/domain/property/useFetchAllProperties';
import useAppUser from 'hooks/useAppUser';
import { PROPERTIES_SORTING_STRATEGY } from 'models/Properties';
import { API_MAX_LIMIT } from 'services/API.constants';
import getPropertiesQuery from 'utils/property/getPropertiesQuery';

export const PROPERTY_CELL_QUERY_OPERATION_NAME = 'PropertiesForAutomationTab';

const propertiesListGqlFields = `
  uid,
  name,
  businessType,
  subUnits{
    uid,
    name,
    businessType,
  },
  unitTypes{
    uid,
    name,
    businessType,
  }`;

const useFetchPropertiesForPropertyCell = () => {
  const { agencyUid } = useAppUser();

  return useFetchAllProperties({
    enabled: !!agencyUid,
    conditions: getPropertiesQuery({
      filters: {
        offset: 0,
        limit: API_MAX_LIMIT,
        topLevelOnly: true,
        sortBy: PROPERTIES_SORTING_STRATEGY.SORT_BY_NAME,
      },
    }),
    fields: propertiesListGqlFields,
    operationName: PROPERTY_CELL_QUERY_OPERATION_NAME,
  });
};

export default useFetchPropertiesForPropertyCell;
